// Whether an AnimatedFigure has come near the viewport: its photo tiles load only then (and never in SSR).
import { createContext, useContext } from "react";

export const FigureNear = createContext(false);
export const useFigureNear = () => useContext(FigureNear);
